/**
 * Daytona sandbox event types for durable event recording (daytona:sandbox-*).
 */
export enum DaytonaEventType {
  SANDBOX_CREATED = 'daytona:sandbox-created',
  SANDBOX_UPDATED = 'daytona:sandbox-updated',
  SANDBOX_DELETED = 'daytona:sandbox-deleted',
  SANDBOX_STARTED = 'daytona:sandbox-started',
  SANDBOX_STOPPED = 'daytona:sandbox-stopped',
  SANDBOX_ARCHIVED = 'daytona:sandbox-archived',
  SANDBOX_STATE_CHANGED = 'daytona:sandbox-state-changed',
  SANDBOX_EXEC = 'daytona:sandbox-exec',
  SANDBOX_FILE_UPDATED = 'daytona:sandbox-file-updated',
  SANDBOX_FORKED = 'daytona:sandbox-forked',
}

/**
 * Pub/sub channel for daytona events.
 */
export const DAYTONA_EVENTS_CHANNEL = 'daytona:events';